module.exports = __webpack_public_path__ + "static/media/rb.2181e63b.png";